export enum RackPositionTypeEnum {
    FRONT = "front",
    REAR = "rear"
}